const loadedScripts: Record<string, Promise<Event>> = {};

export function loadScript(src: string): Promise<Event> {
  if (!loadedScripts[src]) {
    const script = document.createElement('script');
    document.head.appendChild(script);

    loadedScripts[src] = new Promise((resolve, reject) => {
      script.onload = resolve;
      script.onerror = reject;
      script.src = src;
    });
  }

  return loadedScripts[src];
}
